(function () {
  var loadingCopy = [
    'Analisando o formato do rosto...',
    'Posicionando a arma\u00e7\u00e3o...',
    'Ajustando luz e propor\u00e7\u00e3o...',
    'Combinando os detalhes...',
    'Preparando o resultado final...'
  ];
  var visitorId;

  function getVisitorId() {
    if (visitorId) return visitorId;
    var storageKey = 'corato_provador_visitor_id';
    try {
      visitorId = window.localStorage.getItem(storageKey);
      if (!visitorId) {
        visitorId = window.crypto && typeof window.crypto.randomUUID === 'function'
          ? window.crypto.randomUUID()
          : Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
        window.localStorage.setItem(storageKey, visitorId);
      }
    } catch (error) {
      visitorId = Date.now().toString(36) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
    }
    return visitorId;
  }

  function track(name, detail) {
    window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, detail || {});
    }
  }

  function recordEvent(apiBase, eventType, context, errorMessage) {
    if (!apiBase || !context || !context.shop || !context.productId) return;
    var payload = JSON.stringify({
      shop: context.shop,
      productId: context.productId,
      sku: context.sku || '',
      eventType: eventType,
      errorMessage: errorMessage || '',
    });

    if (navigator.sendBeacon) {
      try {
        var blob = new Blob([payload], { type: 'application/json' });
        if (navigator.sendBeacon(apiBase + '/api/provador/events', blob)) return;
      } catch (error) {}
    }

    fetch(apiBase + '/api/provador/events', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: payload,
      keepalive: true,
    }).catch(function () {});
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function cropToSquare(file) {
    return new Promise(function (resolve, reject) {
      if (!file || !/^image\/(png|jpe?g|webp)$/.test(file.type)) {
        reject(new Error('Envie uma foto em PNG ou JPEG.'));
        return;
      }

      var reader = new FileReader();
      reader.onerror = function () { reject(new Error('N\u00e3o conseguimos ler sua foto.')); };
      reader.onload = function () {
        var image = new Image();
        image.onerror = function () { reject(new Error('N\u00e3o conseguimos abrir sua foto.')); };
        image.onload = function () {
          var size = Math.min(image.naturalWidth, image.naturalHeight);
          var canvas = document.createElement('canvas');
          canvas.width = 1024;
          canvas.height = 1024;
          canvas.getContext('2d').drawImage(
            image,
            (image.naturalWidth - size) / 2,
            (image.naturalHeight - size) / 2,
            size,
            size,
            0,
            0,
            1024,
            1024
          );
          resolve(canvas.toDataURL('image/jpeg', 0.9));
        };
        image.src = String(reader.result);
      };
      reader.readAsDataURL(file);
    });
  }

  function readVariants(root) {
    var productId = root.getAttribute('data-product-id');
    var script = document.querySelector('script[data-provador-variants="' + productId + '"]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function createFileInput(capture) {
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.style.display = 'none';
    if (capture) input.setAttribute('capture', 'user');
    document.body.appendChild(input);
    return input;
  }

  function init(root) {
    if (root.__provadorInitialized) return;
    root.__provadorInitialized = true;

    var apiBase = root.getAttribute('data-api-base') || '';
    var shop = root.getAttribute('data-shop');
    var productId = root.getAttribute('data-product-id');
    var variants = readVariants(root);

    if (!apiBase || !shop || !productId) {
      root.hidden = true;
      return;
    }

    function loadConfig(sku) {
      root.innerHTML = '';
      root.hidden = true;
      fetch(apiBase + '/api/provador/config?shop=' + encodeURIComponent(shop) + '&productId=' + encodeURIComponent(productId) + '&sku=' + encodeURIComponent(sku || ''))
        .then(function (res) { return res.json(); })
        .then(function (config) {
          if (!config.configured) return;
          render(root, apiBase, { shop: shop, productId: productId, sku: config.sku || sku || '' });
        })
        .catch(function () { root.hidden = true; });
    }

    loadConfig(root.getAttribute('data-sku') || '');

    document.addEventListener('variant:changed', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant || String(variant.product_id || productId) !== String(productId)) return;
      loadConfig(variant.sku || '');
    });

    document.addEventListener('change', function () {
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      var variant = variants.find(function (item) {
        return String(item.id) === String(input && input.value);
      });
      if (variant) loadConfig(variant.sku || '');
    });
  }

  function render(root, apiBase, context) {
    root.hidden = false;
    root.innerHTML = '';

    var entry = el('div', 'provador-virtual__entry');
    var start = el('button', 'provador-virtual__cta', 'Clique aqui e prove no seu rosto \u2728');
    start.type = 'button';
    entry.appendChild(start);
    root.appendChild(entry);

    var modal = el('div', 'provador-virtual__modal');
    modal.setAttribute('aria-hidden', 'true');
    var dialog = el('div', 'provador-virtual__dialog');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    modal.appendChild(dialog);
    document.body.appendChild(modal);

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
    }

    function openModal() {
      modal.setAttribute('aria-hidden', 'false');
      showInput(dialog, apiBase, context, closeModal);
    }

    start.addEventListener('click', function () {
      track('provador_started', context);
      recordEvent(apiBase, 'provador_started', context);
      openModal();
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });
  }

  function addHeader(dialog, closeModal) {
    dialog.innerHTML = '';
    var close = el('button', 'provador-virtual__close', '\u00d7');
    close.type = 'button';
    close.setAttribute('aria-label', 'Fechar');
    close.addEventListener('click', closeModal);
    dialog.appendChild(close);
    dialog.appendChild(el('h2', 'provador-virtual__title', 'Provador Virtual'));
    dialog.appendChild(el('p', 'provador-virtual__subtitle', 'Experimente at\u00e9 3 modelos de \u00f3culos no seu rosto agora mesmo!'));
  }

  function showInput(dialog, apiBase, context, closeModal) {
    addHeader(dialog, closeModal);

    var privacy = el('div', 'provador-virtual__privacy', 'Sua foto \u00e9 usada apenas para gerar o provador e n\u00e3o \u00e9 armazenada.');
    dialog.appendChild(privacy);

    var choices = el('div', 'provador-virtual__choices');
    var camera = makeChoice('\uD83D\uDCF7', 'Tirar foto agora', 'Use a c\u00e2mera do celular. Fique de frente, com boa luz e o rosto vis\u00edvel.', 'Abrir c\u00e2mera');
    var gallery = makeChoice('\u21E7', 'Selecionar da galeria', 'Escolha uma foto frontal, bem iluminada e com o rosto sem obstru\u00e7\u00f5es.', 'Escolher foto');
    choices.appendChild(camera.card);
    choices.appendChild(gallery.card);
    dialog.appendChild(choices);

    function pick(capture) {
      var input = createFileInput(capture);
      input.addEventListener('change', function () {
        cropToSquare(input.files && input.files[0])
          .then(function (photoDataUrl) {
            input.remove();
            generate(dialog, apiBase, context, closeModal, photoDataUrl);
          })
          .catch(function (error) {
            input.remove();
            addHeader(dialog, closeModal);
            dialog.appendChild(el('p', 'provador-virtual__error', error.message || 'N\u00e3o conseguimos acessar sua c\u00e2mera. Tente enviar uma foto da galeria.'));
            var retry = el('button', 'provador-virtual__button provador-virtual__button--primary', 'Tentar novamente');
            retry.type = 'button';
            retry.addEventListener('click', function () { showInput(dialog, apiBase, context, closeModal); });
            dialog.appendChild(retry);
          });
      });
      input.click();
    }

    camera.card.addEventListener('click', function () { pick(true); });
    gallery.card.addEventListener('click', function () { pick(false); });
  }

  function makeChoice(iconText, title, text, buttonText) {
    var card = el('button', 'provador-virtual__choice');
    card.type = 'button';
    card.appendChild(el('div', 'provador-virtual__icon', iconText));
    card.appendChild(el('p', 'provador-virtual__choice-title', title));
    card.appendChild(el('p', 'provador-virtual__choice-text', text));
    card.appendChild(el('span', 'provador-virtual__button provador-virtual__button--primary', buttonText));
    return { card: card };
  }

  function buildWorkView(dialog, closeModal, photoDataUrl) {
    addHeader(dialog, closeModal);
    var work = el('div', 'provador-virtual__work');
    var left = el('div');
    var right = el('div');
    left.appendChild(el('p', 'provador-virtual__column-label', 'Sua foto'));
    right.appendChild(el('p', 'provador-virtual__column-label', 'Resultado'));

    var photo = el('div', 'provador-virtual__photo');
    var img = document.createElement('img');
    img.alt = 'Sua foto';
    img.src = photoDataUrl;
    photo.appendChild(img);

    var result = el('div', 'provador-virtual__result-box');
    left.appendChild(photo);
    right.appendChild(result);
    work.appendChild(left);
    work.appendChild(right);
    dialog.appendChild(work);
    return result;
  }

  function generate(dialog, apiBase, context, closeModal, photoDataUrl) {
    var copyIndex = 0;
    var result = buildWorkView(dialog, closeModal, photoDataUrl);
    var loader = el('div', 'provador-virtual__loader');
    loader.appendChild(el('div', 'provador-virtual__spinner'));
    var phrase = el('strong', '', loadingCopy[copyIndex]);
    loader.appendChild(phrase);
    loader.appendChild(el('div', 'provador-virtual__dots', '...'));
    result.appendChild(loader);

    var actions = el('div', 'provador-virtual__actions');
    var retryWhileLoading = el('button', 'provador-virtual__button provador-virtual__button--secondary', 'Tentar novamente');
    retryWhileLoading.type = 'button';
    retryWhileLoading.addEventListener('click', function () { showInput(dialog, apiBase, context, closeModal); });
    actions.appendChild(retryWhileLoading);
    dialog.appendChild(actions);

    var interval = window.setInterval(function () {
      copyIndex = (copyIndex + 1) % loadingCopy.length;
      phrase.textContent = loadingCopy[copyIndex];
    }, 3800);

    fetch(apiBase + '/api/provador/generate', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({
        shop: context.shop,
        productId: context.productId,
        sku: context.sku,
        visitorId: getVisitorId(),
        photoDataUrl: photoDataUrl,
      }),
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body.error);
          return body;
        });
      })
      .then(function (body) {
        window.clearInterval(interval);
        track('provador_completed', context);
        showResult(dialog, closeModal, body.imageDataUrl, photoDataUrl, apiBase, context);
      })
      .catch(function (error) {
        window.clearInterval(interval);
        track('provador_error', context);
        result.innerHTML = '';
        result.appendChild(el('p', 'provador-virtual__error', error.message || 'Tente novamente em instantes.'));
      });
  }

  function showResult(dialog, closeModal, imageDataUrl, photoDataUrl, apiBase, context) {
    addHeader(dialog, closeModal);
    var success = el('div', 'provador-virtual__success');
    success.appendChild(el('span', 'provador-virtual__check', 'OK'));
    var text = el('div');
    text.appendChild(el('strong', '', 'Veja como ficou em voc\u00ea!'));
    text.appendChild(el('p', 'provador-virtual__subtitle', 'Provador virtual gerado com sucesso'));
    success.appendChild(text);
    dialog.appendChild(success);

    var image = document.createElement('img');
    image.className = 'provador-virtual__result-image';
    image.alt = 'Resultado do provador virtual';
    image.src = imageDataUrl;
    dialog.appendChild(image);

    var actions = el('div', 'provador-virtual__actions');
    var retry = el('button', 'provador-virtual__button provador-virtual__button--secondary', 'Tentar novamente');
    var close = el('button', 'provador-virtual__button provador-virtual__button--primary', 'Voltar para compra');
    retry.type = 'button';
    close.type = 'button';
    retry.addEventListener('click', function () { generate(dialog, apiBase, context, closeModal, photoDataUrl); });
    close.addEventListener('click', closeModal);
    actions.appendChild(retry);
    actions.appendChild(close);
    dialog.appendChild(actions);
  }

  document.querySelectorAll('[data-provador-virtual]').forEach(init);
})();
